import { css } from "@emotion/react"

const colors = {
  blue: "#1f5da0",
  orange: "#f3971e",
  green: "#005b6b",
} as const

const disabledColor = "#cccccc"

const styles = {
  primary: {
    base: (color: string) => css`
      position: relative;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      height: 34px;
      padding: 0 60px;
      font-family: inherit;
      font-size: 18px;
      color: #fff;
      text-decoration: none;
      cursor: default;
      background-color: ${color};
      border: none;
      border-radius: 5px;
      &:hover {
        opacity: 0.7;
      }
    `,
    disabled: css`
      background-color: ${disabledColor};
      &:hover {
        opacity: revert;
      }
    `,
  },
  inverse: {
    base: (color: string) => css`
      color: ${color};
      background-color: #fff;
      border: 1px solid ${color};
    `,
    disabled: css`
      color: ${disabledColor};
      background-color: #fff;
      border-color: ${disabledColor};
    `,
  },

  short: css`
    padding: 0 23px;
  `,
  loading: css`
    &,
    &:hover {
      opacity: 0.7;
    }
  `,
}

export const resolveButtonClassName = ({
  color = "blue",
  padding = "normal",
  inverse = false,
  isLoading = false,
  disabled = false,
}: {
  color?: "blue" | "orange" | "green"
  padding?: "short" | "normal"
  inverse?: boolean
  isLoading?: boolean
  disabled?: boolean
}) => {
  return css(
    styles.primary.base(colors[color]),
    disabled && styles.primary.disabled,
    inverse && styles.inverse.base(colors[color]),
    inverse && disabled && styles.inverse.disabled,
    padding === "short" && styles.short,
    isLoading && styles.loading
  )
}

export const overrideButtonStyle = (props?: {
  width?: number
  height?: number
  corner?: "sharp" | "round"
  fontSize?: number
}) => {
  if (props === undefined) {
    return props
  }

  const { corner = "round", ...rest } = props
  const style: React.CSSProperties = {
    ...rest,
    borderRadius: corner === "sharp" ? 0 : undefined,
    padding: rest.width === undefined ? undefined : 0,
  }

  return style
}
